import { Package } from 'lucide-react'

import { defineModule } from '@/lib/module-routes'
import { PERMISSION_KEYS } from '@/lib/permissions'

import {
  packageReleaseDetailRoute,
  packageReleaseHistoryRoute,
  packageReleasesRoute,
  packageReleaseUploadRoute,
  packageRolloutNewRoute,
  packageRolloutTrackingRoute,
  packageSourceActivityRoute,
  packageSourceConnectionRoute,
  packageSourceNewRoute,
  packageSourceSettingsRoute,
  packageSourcesRoute,
} from './routes'

export const packagesModule = defineModule({
  routes: [
      packageRolloutTrackingRoute,
    packageSourcesRoute,
    packageSourceNewRoute,
    packageSourceSettingsRoute,
    packageSourceActivityRoute,
    packageSourceConnectionRoute,
    packageRolloutNewRoute,
    packageReleasesRoute,
    packageReleaseHistoryRoute,
    packageReleaseUploadRoute,
    packageReleaseDetailRoute,
  ],
  sections: {
    dataCollection: [{ id: 'packages', label: 'Packages', order: 30 }],
  },
  navigation: {
    dataCollection: [
      {
        to: '/$entityId/packages/releases',
        label: 'Releases',
        icon: Package,
        permission: PERMISSION_KEYS.agentReleaseRead,
        section: 'packages',
        order: 10,
        activeOn: [
          '/$entityId/packages/history/$packageType/$packageId',
          '/$entityId/packages/sources',
          '/$entityId/packages/sources/new',
          '/$entityId/packages/sources/$sourceId',
          '/$entityId/packages/sources/$sourceId/activity',
          '/$entityId/packages/sources/$sourceId/connection',
          '/$entityId/packages/releases/$releaseId/rollouts/new',
          '/$entityId/packages/rollouts/$rolloutId',
        ],
      },
    ],
  },
})
